<template>
  <div class="sp">
    <div class="sp-row">
      <button
        v-for="n in 5"
        :key="n"
        type="button"
        class="sp-star"
        :aria-label="'Rate ' + n + ' star' + (n > 1 ? 's' : '')"
        :disabled="disabled"
        @click="$emit('select', n)"
        @mouseenter="hover = n"
        @mouseleave="hover = 0"
        @focus="hover = n"
        @blur="hover = 0"
      >
        <!-- 40px star per the design; amber #f59e0b fill on hover/selection.
             Path copied from the design bundle (lucide star). -->
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          :fill="n <= displayValue ? '#f59e0b' : 'none'"
          :stroke="n <= displayValue ? '#f59e0b' : '#cbd5e1'"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.11a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.897a.53.53 0 0 1 .294-.905l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z" />
        </svg>
      </button>
    </div>
    <!-- Rating word tracks hover first, then the committed value. -->
    <div class="sp-word">{{ ratingWord }}</div>
  </div>
</template>

<script>
const RATING_WORDS = ['', 'Terrible', 'Poor', 'Okay', 'Great', 'Excellent'];

export default {
  name: 'StarPicker',
  props: {
    value: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { hover: 0 };
  },
  computed: {
    displayValue() {
      return this.hover || this.value;
    },
    ratingWord() {
      return RATING_WORDS[this.displayValue] || ' ';
    },
  },
};
</script>

<style scoped>
.sp {
  text-align: center;
}
.sp-row {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-bottom: 14px;
}
.sp-star {
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0;
  padding: 2px;
  transition: transform 0.12s ease;
}
.sp-star:hover:not(:disabled) {
  transform: scale(1.08);
}
.sp-star:disabled {
  cursor: default;
  opacity: 0.6;
}
.sp-word {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  min-height: 20px;
}
</style>
